import {asyncRouters} from '@/router';

function set_menus(menus) {
    const _arr = [];
    menus.forEach(item => {
        const obj = {};
        obj.menuTitle = item.menuTitle;
        obj.menuType = item.menuType;
        obj.children = [];
        obj.btns = [];
        if (item.permission) obj.permission = item.permission;
        if (item.children.length > 0) {
            const _children = set_menus(item.children);
            _children.forEach(item2 => {
                if (item2.menuType === 'M') {
                    obj.children.push(item2)
                } else {
                    obj.btns.push(item2)
                }
            })
        } else {
            delete obj.children;
            delete obj.btns;
        }
        _arr.push(obj);
    })
    return _arr;
}

function getAsyncObject(_name, list = asyncRouters) {
    let _item = null;
    for (let i = 0; i < list.length; i++) {
        const item = list[i];
        if (item.meta) {
            if (item.meta.title === _name) {
                const {path, name, meta, component, children} = item;
                _item = {path, name, meta, component};
                if (children && children.length === 1 && !children[0].meta) {
                    _item.children = children;
                }
                break;
            } else {
                if (item.children) {
                    const _o = getAsyncObject(_name, item.children);
                    if (_o) {
                        _item = _o;
                        break;
                    }
                }
            }
        }
    }
    return _item;
}

function get_menus(menus) {
    const _arr = [];
    menus.forEach(item => {
        const obj = {};
        const _async = getAsyncObject(item.menuTitle);
        obj.meta = {title: item.menuTitle}
        obj.path = _async.path
        obj.name = _async.name
        obj.component = _async.component;
        if (_async.meta && _async.meta.icon) obj.meta.icon = _async.meta.icon;
        if (_async.children) obj.children = _async.children;
        if (item.btns && item.btns.length > 0) {
            const _b = [];
            item.btns.forEach(item2 => {
                if (item2.permission) _b.push(item2.permission)
            });
            obj.meta.role = _b.join(',');
        }
        if (item.children && item.children.length > 0) {
            obj.children = get_menus(item.children);
        }
        _arr.push(obj);
    })
    return _arr;
}

const user = {
    namespaced: true,
    state: {
        token: void 0,
        userInfo: null,
        asyncRouter: []
    },
    getters: {
        getToken(state) {
            return state.token
        },
        getAsyncRouter(state) {
            return state.asyncRouter
        },
    },
    mutations: {
        REMOVE_USERINFO(state) {
            state.userInfo = null
        },
        REMOVE_TOKEN: (state) => {
            state.token = void 0;
            state.asyncRouter = [];
        },
        SET_TOKEN: (state, token) => {
            state.token = token;
        },
    },
    actions: {
        createRouters({state}, menus) {
            return new Promise((resolve) => {
                const _m = set_menus(menus);
                const _arr2 = get_menus(_m);
                _arr2.forEach(item => {
                    if (item.children && item.children.length > 0) {
                        const _p = item.path === '/' ? '/' : item.path + '/'
                        item.redirect = _p + item.children[0].path;
                    }
                })
                state.asyncRouter = _arr2;
                resolve(_arr2)
            })
        }
    },
}

export default user;
